import client from "./../components/misc/login/http-request";

/**
 * Method to fetch all auditoriums / lecture rooms from the backend.
 * @returns Array of objects for all rooms.
 */
export const fetchRooms = async () => {
  const res = await client.get("/api/v1/auditoriums");
  return res.data;
};

/**
 * Method to fetch the data for a specific room from the backend.
 * @param {string} ID of the room the data is for.
 * @returns Object of data for the selected room.
 */
export const fetchSelectedRoomData = async (ID) => {
  const res = await client.get(`/api/v1/auditoriums/${ID}`);
  return res.data;
};

/**
 * Method to fetch the trouble reports / incidents for a specific room from the backend.
 * @param {string} ID of the room the data is for.
 * @returns Array of objects for all of the rooms' existing reports within the last week. May return an empty array, if no reports were found. Will only return data, if the user is connected to the campus wifi.
 */
export const fetchTroubleReports = async (ID) => {
  const res = await client.get(`/api/v1/incidents/${ID}`);
  return res.data;
};

/**
 * Method to fetch the allocations for a specific room from the backend.
 * @param {string} ID of the room the data is for.
 * @returns Array of objects for all of the rooms' existing allocations. Will return an error, if the user is not logged in.
 */
export const fetchRoomAllocations = async (ID) => {
  const res = await client.get(`/api/v1/occupancies/${ID}`);
  return res.data;
};
